// extracted by mini-css-extract-plugin
module.exports = {"container":"general_container__2A7-C","fieldsContainer":"general_fieldsContainer__3Bap0","row":"general_row__2pQBC","field":"general_field__Cn0WJ"};